import * as yup from 'yup';

export interface PrimaryFormValues {
  ['primaryApplicant.legalFirstName']: string;
  ['primaryApplicant.legalLastName']: string;
}

export interface SecondaryFormValues {
  ['secondApplicant.legalFirstName']: string;
  ['secondApplicant.legalLastName']: string;
}

export type LegalFirstNameFieldName =
  | 'primaryApplicant.legalFirstName'
  | 'secondApplicant.legalFirstName';

export type LegalLastNameFieldName =
  | 'primaryApplicant.legalLastName'
  | 'secondApplicant.legalLastName';

export const legalFirstNameValidation = yup
  .string()
  .nullable()
  .required('First Name is required');

export const legalLastNameValidation = yup
  .string()
  .nullable()
  .required('Last Name is required');
